import React from "react";
import Shop from "../components/shop/Shop";

const ShopPage = () => {
  return <Shop />;
};

export default ShopPage;
